// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var H2 = function H2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h2-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 3.582c0-.426.344-.77.77-.77h3.585a.769.769 0 1 1 0 1.54H3.328V8.96h7.68V4.35H9.984a.769.769 0 1 1 0-1.538h3.582a.768.768 0 1 1 0 1.539h-1.023v11.261h1.023a.768.768 0 1 1 0 1.54H9.984a.768.768 0 1 1 0-1.54h1.024v-5.12h-7.68v5.12h1.024a.768.768 0 1 1 0 1.54H.77a.774.774 0 0 1-.77-.774c0-.426.344-.77.77-.77h1.023V4.348H.77A.765.765 0 0 1 0 3.582m17.45 7.332c-.31 0-.61.137-.829.383l-.441.5a.425.425 0 0 1-.653 0 .56.56 0 0 1 0-.73l.446-.497c.394-.437.925-.683 1.48-.683 1.152 0 2.09 1.047 2.09 2.34 0 .62-.219 1.214-.613 1.656l-1.961 2.199h2.574c.254 0 .46.23.46.516 0 .285-.206.515-.46.515h-3.691a.46.46 0 0 1-.426-.32.57.57 0 0 1 .097-.562l2.75-3.079c.22-.246.344-.578.344-.925 0-.723-.523-1.309-1.168-1.309z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "h2-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
